// constants.js

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

// pubsub.js

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// mm-analytics.js — anonymous Mix & Match popup tracking
// Sends two anonymous facts ("popup_opened", "item_added") to the Gadget app.
// No customer data, identifiers, IP, or session info is sent.
// Body is text/plain JSON so the browser skips the CORS preflight and
// navigator.sendBeacon works (fire-and-forget).
// Gadget app slug is "deux-par-deux" (see .gadget/sync.json in the app repo).
// Dev:  https://deux-par-deux--development.gadget.app/mm-event
// Prod: https://deux-par-deux.gadget.app/mm-event  (switch when going live)
const MM_ANALYTICS_ENDPOINT =
  "https://deux-par-deux--development.gadget.app/mm-event";
// Optional shared secret — must match the app's MM_ANALYTICS_TOKEN env var.
// Leave empty to send no token (only works if the app's var is also unset).
const MM_ANALYTICS_TOKEN = "";

window.mmTrack = function mmTrack(eventType, payload) {
  try {
    const body = JSON.stringify({
      eventType,
      occurredAt: new Date().toISOString(),
      pageUrl: window.location.pathname,
      ...(payload || {}),
    });

    // sendBeacon can't set custom headers — only use it when no token is needed.
    if (!MM_ANALYTICS_TOKEN && navigator.sendBeacon) {
      const blob = new Blob([body], { type: "text/plain" });
      if (navigator.sendBeacon(MM_ANALYTICS_ENDPOINT, blob)) return;
    }

    const headers = { "Content-Type": "text/plain" };
    if (MM_ANALYTICS_TOKEN) headers["x-mm-token"] = MM_ANALYTICS_TOKEN;
    fetch(MM_ANALYTICS_ENDPOINT, {
      method: "POST",
      headers,
      body,
      keepalive: true,
      mode: "cors",
    }).catch(() => {});
  } catch (e) {
    /* never let analytics break the storefront */
  }
};

// global.js
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    if (summaryElement.classList.contains("header__icon")) {
      document.body.classList.add(
        `overflow-hidden-${this.dataset.breakpoint}`,
        `MobileMenuOn`
      );
    } else {
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });

    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
      `MobileMenuOn`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    if (summaryElement.classList.contains("header__icon")) {
      document.body.classList.add(
        `overflow-hidden-${this.dataset.breakpoint}`,
        `MobileMenuOn`
      );
    } else {
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    if (!itemsCount) return;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];
    if (!currentSlide || !nextSlide) return;

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  connectedCallback() {
    // Handle pre-selected variant on page load
    this.handleInitialVariantSelection();
    // product-form is defined later in this bundle; sync CTL cards after it upgrades
    // and attaches change listeners (otherwise preselect's dispatch is a no-op on load).
    queueMicrotask(() => this.preselectCtlVariants());
  }

  handleInitialVariantSelection() {
    const selectedVariantId = this.dataset.selectedVariantId;
    
    if (!selectedVariantId) {
      // No variant selected - ensure class is set
      this.classList.add('variant-not-selected');
      this.classList.remove('variant-selected');
      return;
    }

    // Find the variant data
    const variantData = this.getVariantData();
    const selectedVariant = variantData.find(v => v.id.toString() === selectedVariantId);
    
    if (!selectedVariant) return;

    // Pre-select the options in the UI
    selectedVariant.options.forEach((optionValue, index) => {
      // Find and check the radio button or select the dropdown option
      const fieldset = this.querySelectorAll('fieldset, .product-form__input--dropdown')[index];
      
      if (fieldset) {
        if (fieldset.tagName === 'FIELDSET') {
          // Radio buttons
          const radio = fieldset.querySelector(`input[value="${optionValue}"]`);
          if (radio) {
            radio.checked = true;
          }
        } else {
          // Dropdown
          const select = fieldset.querySelector('select');
          if (select) {
            select.value = optionValue;
          }
        }
      }
    });

    // Update the current variant and trigger all updates
    this.updateOptions();
    this.updateMasterId();
    
    if (this.currentVariant) {
      this.classList.add('variant-selected');
      this.classList.remove('variant-not-selected');
      
      // Trigger all variant updates without toggling add button to disabled
      this.updateVariantInput();
      this.renderProductInfo();
      this.updatePickupAvailability();
      this.updateMedia();
      this.updateVariantStatuses();
      
      // Set proper button state
      this.toggleAddButton(
        !this.currentVariant.available,
        this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.unavailable
      );
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      this.classList.add('variant-not-selected');
      this.classList.remove('variant-selected');
    } else {
      this.classList.add('variant-selected');
      this.classList.remove('variant-not-selected');
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    this.preselectCtlVariants();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked
          )?.value;
        }
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    document.querySelectorAll(
      '.staticAddToCart .product-form__buttons, .stickyAddToCart .product-form__buttons'
    ).forEach(el => el.classList.toggle('soldoutVariant', !this.currentVariant.available));
    if (document.querySelectorAll("[js-variantmetaint]").length > 0) {
      var metaAttrV = document
        .querySelector(
          `.LytProductFormInput input[value="${this.currentVariant.title}"]`
        )
        .getAttribute("data-variant-meta");
      if (
        typeof metaAttrV !== "undefined" &&
        metaAttrV !== false &&
        !metaAttrV.includes("*")
      ) {
        document.querySelector("[js-variantmetaint]").innerHTML = metaAttrV;
        document
          .querySelector("[js-variantmetaint]")
          .closest(".cv_product_variant_des")
          .classList.add("visibleOP");
      } else {
        document
          .querySelector("[js-variantmetaint]")
          .closest(".cv_product_variant_des")
          .classList.remove("visibleOP");
      }
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value
            );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );
        // Support multiple button prices (e.g., sticky add to cart)
        const buttonPrices = document.querySelectorAll(
          '[id^="product-form__buttons--price"]'
        );
        const newButtonPrice = html.getElementById(
          "product-form__buttons--price"
        );
        
        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");
        
        if (newButtonPrice) {
          // Update all button prices
          buttonPrices.forEach((buttonPrice) => {
            if (buttonPrice) {
              buttonPrice.innerHTML = newButtonPrice.innerHTML;
            }
          });
          
          // Also update product price display
          const productPriceDisplay = document.querySelector(".product__price__display");
          if (productPriceDisplay) {
            productPriceDisplay.innerHTML = newButtonPrice.innerHTML;
          }
        }
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }
        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }
        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const deliveryLabelSource = html.getElementById(
          `delivery-shipping-label-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const deliveryLabelDestination = document.getElementById(
          `delivery-shipping-label-${this.dataset.section}`
        );
        if (deliveryLabelSource && deliveryLabelDestination) {
          deliveryLabelDestination.innerHTML = deliveryLabelSource.innerHTML;
        }

        const lowStockSource = html.getElementById(
          `low-stock-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const lowStockDestination = document.getElementById(
          `low-stock-${this.dataset.section}`
        );
        if (lowStockSource && lowStockDestination) {
          lowStockDestination.innerHTML = lowStockSource.innerHTML;
          lowStockDestination.hidden = lowStockSource.hidden;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("hidden");
        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );
        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.addToCart
        );
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        document.querySelectorAll(".RemoveFrom").forEach((target) => {
          target.remove();
        });
        document.querySelectorAll(".product-form__submit").forEach((target) => {
          target.classList.remove("disabled");
        });
        if (
          document.querySelectorAll(`[sizepayprice]`).length > 0 &&
          document.querySelectorAll(
            ".sezzle-payment-amount.sezzle-button-text.sezzleindex-0"
          ).length > 0
        ) {
          let PriceDividedBy = document
            .querySelector(`[sizepayprice]`)
            .getAttribute("sizepayprice");
          document.querySelector(
            ".sezzle-payment-amount.sezzle-button-text.sezzleindex-0"
          ).innerHTML = `${PriceDividedBy}`;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    // Support multiple product forms (e.g., sticky add to cart)
    const productForms = document.querySelectorAll(
      `[id^="product-form-${this.dataset.section}"]`
    );
    if (!productForms.length) return;

    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector(
        '[name="add"] .product-form__buttons--main'
      );
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text && addButtonText) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        if (addButton.dataset.name == "pre_order") {
          if (document.querySelectorAll('[languagelocale="fr"]').length > 0) {
            if (addButtonText) addButtonText.textContent = "PRÉCOMMANDE";
          } else {
            if (addButtonText) addButtonText.textContent = "Pre-order";
          }
        } else {
          if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    // Support multiple product forms (e.g., sticky add to cart)
    const productForms = document.querySelectorAll(
      `[id^="product-form-${this.dataset.section}"]`
    );
    
    productForms.forEach((button) => {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      if (addButton && addButtonText) {
        addButtonText.textContent = window.variantStrings.unavailable;
      }
    });

    // Update price and inventory info (only once, not per form)
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }
  // `variant` defaults to the page selection, else the variant last added from
  // this page (_mmAddedVariant, set by openCtlAtcModal): single-size products
  // keep no page selection (variant-not-selected), so without it no card would
  // be size-matched in the ATC popup (incl. overflow cards loaded later).
  preselectCtlVariants(variant = this.currentVariant || this._mmAddedVariant) {
    if (!variant) return;

    // Read main product's variant → size_grouping metafield map (rendered by product-variant-picker.liquid)
    let sizeGroupingMap = {};
    try {
      const mapEl = this.querySelector('.product-variant-size-grouping-data');
      if (mapEl) sizeGroupingMap = JSON.parse(mapEl.textContent);
    } catch { /* non-critical, fall through */ }
    const currentSizeGrouping = sizeGroupingMap[String(variant.id)] ?? null;
    const currentSizeGroupingArray = Array.isArray(currentSizeGrouping) ? currentSizeGrouping : [];
    const currentSizeGroupingSet = new Set(currentSizeGroupingArray.map(v => String(v).toLowerCase().trim()));

    const normalize = str => str.toLowerCase().trim();

    // Handles trailing-month compound sizes like "2/6m" → ["2m", "6m"].
    // Segments like "12m/18m" or "S/M" are returned unchanged.
    const toSubsizes = str => {
      const parts = normalize(str).split('/').map(s => s.trim()).filter(Boolean);
      const last = parts[parts.length - 1] ?? '';
      const isTrailingMonthCompound =
        parts.length > 1 &&
        /^\d+m$/.test(last) &&
        parts.slice(0, -1).every(p => /^\d+$/.test(p));
      return isTrailingMonthCompound
        ? parts.map(p => (p.endsWith('m') ? p : p + 'm'))
        : parts;
    };

    // Parse a single normalized subsize into { value, unit } for range checks.
    // unit: 'm' for months (e.g. "6m"), 'y' for dimensionless years/numbers (e.g. "4").
    // Returns null for non-numeric sizes like "xs".
    const parseNumericSize = s => {
      if (/^\d+m$/.test(s)) return { value: parseInt(s, 10), unit: 'm' };
      if (/^\d+$/.test(s))  return { value: parseInt(s, 10), unit: 'y' };
      return null;
    };

    const selectedTitle    = normalize(variant.title);
    const selectedSubsizes = toSubsizes(variant.title);
    const selectedParsed   = selectedSubsizes.map(parseNumericSize);

    const findMatchByLevels = (pool, { allowFallback, preferAvailableFirst = false }) => {
      if (!pool.length) return { match: null, level: null };
      const availablePool = pool.filter(v => v.available);
      const fromPreferred = preferAvailableFirst && availablePool.length ? availablePool : pool;
      const fromAny = pool;

      // Level 0: metafield array intersection on custom.variant_size_grouping_filter
      if (currentSizeGroupingSet.size > 0) {
        const matcher0 = v => {
          if (!Array.isArray(v.size_grouping) || v.size_grouping.length === 0) return false;
          return v.size_grouping.some(groupVal =>
            currentSizeGroupingSet.has(String(groupVal).toLowerCase().trim())
          );
        };
        const level0 = fromPreferred.find(matcher0) || fromAny.find(matcher0);
        if (level0) return { match: level0, level: 0 };
      }

      // Level 1: exact title match (normalized)
      const matcher1 = v => normalize(v.title) === selectedTitle;
      const level1 = fromPreferred.find(matcher1) || fromAny.find(matcher1);
      if (level1) return { match: level1, level: 1 };

      // Level 2: compound intersection — any subsize string appears in the other
      const matcher2 = v => {
        const vSubsizes = toSubsizes(v.title);
        return selectedSubsizes.some(sub => vSubsizes.includes(sub));
      };
      const level2 = fromPreferred.find(matcher2) || fromAny.find(matcher2);
      if (level2) return { match: level2, level: 2 };

      // Level 3: range check — M&M variant is a 2-part numeric range (e.g. "6/24m", "4/7").
      // At least one parsed subsize of the current product must fall within [lo, hi].
      // Units must match: months only compared to months, dimensionless to dimensionless.
      const matcher3 = v => {
        const vParts = toSubsizes(v.title);
        if (vParts.length !== 2) return false;
        const lo = parseNumericSize(vParts[0]);
        const hi = parseNumericSize(vParts[1]);
        if (!lo || !hi || lo.unit !== hi.unit) return false;
        return selectedParsed.some(parsed => {
          if (!parsed || parsed.unit !== lo.unit) return false;
          return parsed.value >= lo.value && parsed.value <= hi.value;
        });
      };
      const level3 = fromPreferred.find(matcher3) || fromAny.find(matcher3);
      if (level3) return { match: level3, level: 3 };

      // Level 4: fallback — first available variant (default click MM only)
      if (allowFallback) {
        const firstAvailable = pool.find(v => v.available) || null;
        if (firstAvailable) return { match: firstAvailable, level: 4 };
      }

      return { match: null, level: null };
    };

    // The horizontal card has a single native <select>. In default popup mode it
    // shows the full variant list (incl. OOS); in ATC popup mode CustomDialog
    // hides OOS options. We always preselect the best *available* match when one
    // exists (atcMatch); otherwise we fall back to the best overall match. This
    // keeps the same selection visible whether the popup is in default or ATC
    // mode, so users don't see a different size when the popup transitions.
    // .product-card--mm-atc-hidden still tracks "no available match exists",
    // which CustomDialog uses to filter cards in ATC mode.
    document.querySelectorAll('.product-card--mm').forEach(form => {
      const jsonEl = form.querySelector('.product-variants-data-json');
      if (!jsonEl) return;

      let variants;
      try {
        variants = JSON.parse(jsonEl.textContent).variants;
      } catch {
        return;
      }

      const available = variants.filter(v => v.available);
      const defaultResult = findMatchByLevels(variants, { allowFallback: true, preferAvailableFirst: true });
      const atcResult = findMatchByLevels(available, { allowFallback: false });
      // Footwear (data-mm-size-required): shoe sizes never match clothing sizes,
      // so it stays visible in ATC mode without a match and gets no level-4
      // first-available guess — the "Select a size" placeholder stays selected.
      const sizeRequired = form.dataset.mmSizeRequired === 'true';
      const defaultMatch = sizeRequired ? null : defaultResult.match;
      const atcMatch = atcResult.match;

      form.classList.toggle('product-card--mm-atc-hidden', !atcMatch && !sizeRequired);
      // Unmatched footwear only fills ATC slots left over by size-matched cards.
      form.classList.toggle('product-card--mm-size-pending', !atcMatch && sizeRequired);

      console.log('[M&M preselect]', {
        currentVariantTitle: variant.title,
        currentVariantSizeGrouping: currentSizeGroupingArray,
        mixMatchProductTitle: form.querySelector('.product-card--horizontal__title')?.textContent?.trim() || null,
        defaultMatchedVariantTitle: defaultMatch?.title ?? null,
        defaultMatchSizeGrouping: Array.isArray(defaultMatch?.size_grouping) ? defaultMatch.size_grouping : [],
        defaultLevelUsed: defaultResult.level,
        atcMatchedVariantTitle: atcMatch?.title ?? null,
        atcMatchSizeGrouping: Array.isArray(atcMatch?.size_grouping) ? atcMatch.size_grouping : [],
        atcLevelUsed: atcResult.level,
      });

      const select = form.querySelector('select.product-variant-id');
      if (!select) return;

      // Prefer an available match (works for both popup modes); otherwise the
      // best full-pool match (might be OOS — that's the click-mode behavior).
      const preferredMatch = atcMatch || defaultMatch;
      if (preferredMatch) {
        const option = [...select.options].find(o => Number(o.value) === preferredMatch.id);
        if (option) select.value = String(preferredMatch.id);
      } else if (sizeRequired && select.dataset.mmUserPicked !== 'true') {
        select.value = '';
      }

      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }
          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

//   localization-form.js

if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(min-width: 750px)");
        this.header = document.querySelector(".header-wrapper");
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper"),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector(".country-selector__close-button"),
          resetButton: this.querySelector(".country-filter__reset-button"),
          searchIcon: this.querySelector(".country-filter__search-icon"),
          liveRegion: this.querySelector("#sr-country-search-results"),
        };
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
        this.addEventListener("keydown", this.onContainerKeyDown.bind(this));
        this.addEventListener("focusout", this.closeSelector.bind(this));
        this.elements.button.addEventListener(
          "click",
          this.openSelector.bind(this)
        );

        if (this.elements.search) {
          this.elements.search.addEventListener(
            "keyup",
            this.filterCountries.bind(this)
          );
          this.elements.search.addEventListener(
            "focus",
            this.onSearchFocus.bind(this)
          );
          this.elements.search.addEventListener(
            "blur",
            this.onSearchBlur.bind(this)
          );
          this.elements.search.addEventListener(
            "keydown",
            this.onSearchKeyDown.bind(this)
          );
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener(
            "click",
            this.hidePanel.bind(this)
          );
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener(
            "click",
            this.resetFilter.bind(this)
          );
          this.elements.resetButton.addEventListener("mousedown", (event) =>
            event.preventDefault()
          );
        }

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this))
        );
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
        if (this.elements.search) {
          this.elements.search.value = "";
          this.filterCountries();
          this.elements.search.setAttribute("aria-activedescendant", "");
        }
        document.body.classList.remove("overflow-hidden-mobile");
        document
          .querySelector(".menu-drawer")
          .classList.remove("country-selector-open");
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll("a")).filter(
          (item) => !item.parentElement.classList.contains("hidden")
        );
        let focusedItemIndex = focusableItems.findIndex(
          (item) => item === document.activeElement
        );
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case "ARROWUP":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0
                ? focusableItems[focusedItemIndex - 1]
                : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case "ARROWDOWN":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1
                ? focusableItems[focusedItemIndex + 1]
                : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex(
            (item) => item === document.activeElement
          );
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute(
              "aria-activedescendant",
              focusableItems[focusedItemIndex].id
            );
          } else {
            this.elements.search.setAttribute("aria-activedescendant", "");
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case "ESCAPE":
            if (this.elements.button.getAttribute("aria-expanded") == "false")
              return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case "SPACE":
            if (this.elements.button.getAttribute("aria-expanded") == "true")
              return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString()
        );
        if (!document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.add("overflow-hidden-mobile");
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute("data-prevent-hide")) {
          this.header.preventHide = true;
        }
        document
          .querySelector(".menu-drawer")
          .classList.add("country-selector-open");
        document.body.classList.add("localizationOpened");
      }

      closeSelector(event) {
        if (
          event.target.classList.contains("country-selector__overlay") ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
        document.body.classList.remove("localizationOpened");
      }

      filterCountries() {
        const searchValue = this.elements.search.value.toLowerCase();
        const popularCountries = this.querySelector(".popular-countries");
        const allCountries = this.querySelectorAll("a");
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle("hidden", !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle("hidden", searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = item
            .querySelector(".country")
            .textContent.toLowerCase();
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove("hidden");
            visibleCountries++;
          } else {
            item.parentElement.classList.add("hidden");
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.countrySelectorSearchCount.replace(
              "[count]",
              visibleCountries
            );
        }

        this.querySelector(".country-selector").scrollTop = 0;
        this.querySelector(".country-selector__list").scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = "";
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add(
          "country-filter__search-icon--hidden"
        );
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove(
            "country-filter__search-icon--hidden"
          );
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === "ENTER") {
          event.preventDefault();
        }
      }
    }
  );
}

class CustomLanguageSw extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".countryChgcurc").forEach((elm) => {
      elm.addEventListener("click", (target) => {
        target.preventDefault();
        if (target.currentTarget.classList.contains("active")) {
        } else {
          const formCurrency = this.querySelector("form");
          this.elements = {
            input: this.querySelector(
              'input[name="locale_code"], input[name="country_code"]'
            ),
          };
          this.elements.input.value = target.currentTarget.dataset.value;
          if (formCurrency) formCurrency.submit();
        }
      });
    });
  }
}
customElements.define("custom-localization-form", CustomLanguageSw);
//   cart-drawer-script.js
//   details-modal.js

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden", "SearchModalActive");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden", "SearchModalActive");
  }
}

customElements.define("details-modal", DetailsModal);
//   search-form.js
// class SearchForm extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input[type="search"]');
//     this.resetButton = this.querySelector('button[type="reset"]');

//     if (this.input) {
//       this.input.form.addEventListener("reset", this.onFormReset.bind(this));
//       this.input.addEventListener(
//         "input",
//         debounce((event) => {
//           this.onChange(event);
//         }, 300).bind(this)
//       );
//     }
//   }

//   toggleResetButton() {
//     const resetIsHidden = this.resetButton.classList.contains("hidden");
//     if (this.input.value.length > 0 && resetIsHidden) {
//       this.resetButton.classList.remove("hidden");
//     } else if (this.input.value.length === 0 && !resetIsHidden) {
//       this.resetButton.classList.add("hidden");
//     }
//   }

//   onChange() {
//     this.toggleResetButton();
//   }

//   shouldResetForm() {
//     return !document.querySelector('[aria-selected="true"] a');
//   }

//   onFormReset(event) {
//     // Prevent default so the form reset doesn't set the value gotten from the url on page load
//     event.preventDefault();
//     // Don't reset if the user has selected an element on the predictive search dropdown
//     if (this.shouldResetForm()) {
//       this.input.value = "";
//       this.input.focus();
//       this.toggleResetButton();
//     }
//   }
// }

// customElements.define("search-form", SearchForm);
//   product-form.js

function scrollToTargetAdjusted(element) {
  let headerOffset, elementPosition, offsetPosition;
  headerOffset = document.querySelector(".header-wrapper").scrollHeight;
  elementPosition = element.getBoundingClientRect().top;
  offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  window.scrollTo({ top: offsetPosition, behavior: "smooth" });
}

const MM_ATC_FREQ_STORAGE_KEY = 'mm-atc-popup-frequency-v1';

function updateMmDebugPanels() {
  const debugOutputs = document.querySelectorAll('[data-mm-debug-output]');
  if (!debugOutputs.length) return;
  const ctlDialog = document.querySelector('.ctl-new__dialog');

  const toInt = (value, fallback = null) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const currentSettings = ctlDialog ? {
    frequencyLimitsEnabled: ctlDialog.dataset.mmAtcFrequencyLimits === 'true',
    maxShowsPerProduct: toInt(ctlDialog.dataset.mmAtcMaxShowsPerProduct),
    maxShowsGlobal: toInt(ctlDialog.dataset.mmAtcMaxShowsGlobal),
    cooldownMinutes: toInt(ctlDialog.dataset.mmAtcCooldownMinutes),
    sessionWindowMinutes: toInt(ctlDialog.dataset.mmAtcSessionWindowMinutes),
  } : null;

  let raw = null;
  try {
    raw = localStorage.getItem(MM_ATC_FREQ_STORAGE_KEY);
  } catch {
    raw = null;
  }

  let savedState = null;
  if (raw) {
    try {
      savedState = JSON.parse(raw);
    } catch {
      savedState = raw;
    }
  }

  const now = Date.now();
  const saved = (savedState && typeof savedState === 'object') ? savedState : {};
  const firstShownAt = saved.firstShownAt || null;
  const expiresAt = saved.expiresAt || null;
  const windowMinutes = currentSettings?.sessionWindowMinutes ?? null;
  const sessionUsedMinutes = (firstShownAt && windowMinutes != null)
    ? Math.min(windowMinutes, Math.max(0, Math.floor((now - firstShownAt) / 60000)))
    : null;
  const globalUsed = saved.globalCount ?? 0;
  const globalLimit = currentSettings?.maxShowsGlobal ?? null;
  const perProductMax = currentSettings?.maxShowsPerProduct ?? null;
  const perProductProgress = saved.perProduct && typeof saved.perProduct === 'object'
    ? Object.entries(saved.perProduct).map(([key, count]) => `${key}: ${count} / ${perProductMax ?? '-'}`).join(', ')
    : '-';
  const cooldownLimit = currentSettings?.cooldownMinutes ?? null;
  const cooldownUsed = saved.lastShownAt && cooldownLimit != null
    ? Math.min(cooldownLimit, Math.max(0, Math.floor((now - saved.lastShownAt) / 60000)))
    : null;

  const rows = [
    ['Frequency limits (setting)', currentSettings?.frequencyLimitsEnabled ? 'On' : 'Off'],
    ['Cooldown (minutes)', (cooldownUsed != null && cooldownLimit != null) ? `${cooldownUsed} / ${cooldownLimit}` : '-'],
    ['Session progress', (sessionUsedMinutes != null && windowMinutes != null) ? `${sessionUsedMinutes} / ${windowMinutes}` : '-'],
    ['Popup views (session total)', (globalLimit != null) ? `${globalUsed} / ${globalLimit}` : `${globalUsed}`],
    ['Popup views (per product)', perProductProgress],
    ['Popup first shown', firstShownAt ? new Date(firstShownAt).toLocaleString() : '-'],
    ['Popup last shown', saved.lastShownAt ? new Date(saved.lastShownAt).toLocaleString() : '-'],
    ['Session expires at', expiresAt ? new Date(expiresAt).toLocaleString() : '-'],
  ];

  debugOutputs.forEach(output => {
    output.innerHTML = rows
      .map(([label, value]) => `<tr><td>${label}</td><td>${String(value)}</td></tr>`)
      .join('');
  });
}

document.addEventListener('click', (event) => {
  const resetButton = event.target.closest('[data-mm-debug-reset]');
  if (resetButton) {
    try {
      localStorage.removeItem(MM_ATC_FREQ_STORAGE_KEY);
    } catch {
      // ignore
    }
    updateMmDebugPanels();
    return;
  }

  const clearCartButton = event.target.closest('[data-mm-debug-clear-cart]');
  if (!clearCartButton) return;

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  })
    .then(() => {
      window.location.reload();
    })
    .catch((error) => {
      console.error('Failed to clear cart for debug:', error);
    });
});

document.addEventListener('DOMContentLoaded', updateMmDebugPanels);

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.variantsData = JSON.parse(this.querySelector(".product-variants-data-json")?.textContent || "{}");

        // Horizontal cards (M&M + Look page) carry a single native select. PDP
        // doesn't use a select at all — its variant picker dispatches change
        // separately. We listen on whatever select.product-variant-id we find.
        const variantSelects = this.querySelectorAll("select.product-variant-id");
        if (variantSelects.length && this.variantsData.variants?.length > 0) {
          const onVariantChange = this.onVariantChange.bind(this);
          variantSelects.forEach((select) =>
            select.addEventListener("change", onVariantChange)
          );
        }

        // Footwear M&M cards: remember a size the shopper picked so a later
        // preselect (variant change / ATC popup) doesn't reset it to the placeholder.
        if (this.dataset.mmSizeRequired === 'true') {
          variantSelects.forEach((select) =>
            select.addEventListener('change', (evt) => {
              if (evt.isTrusted && select.value) select.dataset.mmUserPicked = 'true';
            })
          );
        }
        

        this.submitButton = this.querySelector('[type="submit"]')
          || (this.form.id && document.querySelector('[type="submit"][form="' + CSS.escape(this.form.id) + '"]'));

        if (this.submitButton) this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.openCtlAtcAfterAdd = false;
        this.lastAddedCartItem = null;

        // Horizontal cards rely on onVariantChange to set the correct initial
        // ATC vs Notify-Me/Klaviyo visibility. On M&M cards, preselectCtlVariants
        // dispatches change for us; on Look-page cards there's no preselect, so
        // we synthesize one initial change here. Defer to a microtask so any
        // late attribute setup is in place first.
        if (this.classList.contains('product-card--horizontal')) {
          queueMicrotask(() => {
            const select = this.querySelector('select.product-variant-id');
            select?.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      }

      onVariantChange(evt) {

        const variantId = Number(evt.target.value);
        const variant = this.variantsData.variants.find(v => v.id === variantId);

        if (variant) {
          const priceEl = this.querySelector(".product-card__price-current");
          const compareEl = this.querySelector(".product-card__price-original");
          if (priceEl) priceEl.textContent = variant.price;
          if (compareEl) compareEl.textContent = variant.compare_at_price;
        }

        // Horizontal cards handle OOS variant selection differently depending on
        // context. M&M cards live on the product template, where Klaviyo's BIS
        // injection only targets the main product — they use a static link to
        // the PDP with highlight_klaviyo=1. Look-page (and other non-product
        // templates) cards use Klaviyo's normal BIS button injection.
        if (this.classList.contains('product-card--horizontal')) {
          const atcBtn = this.querySelector('.product-form__submit');
          const isOOS = variant ? !variant.available : false;

          if (this.dataset.mmSizeRequired === 'true') {
            // No size yet (placeholder) → plain ATC button, which asks for a size on click.
            if (!evt.target.value) atcBtn?.classList.remove('hidden');
            else this.classList.remove('product-card--mm-size-error');
          }

          if (this.classList.contains('product-card--mm')) {
            const notifyLink = this.querySelector('.product-card__notify-me');
            if (isOOS) {
              const base = this.dataset.productUrl || '';
              if (notifyLink) {
                notifyLink.href = `${base}?variant=${variantId}&highlight_klaviyo=1`;
                notifyLink.classList.add('product-card__notify-me--visible');
              }
              atcBtn?.classList.add('hidden');
            } else {
              notifyLink?.classList.remove('product-card__notify-me--visible');
              if (variant?.available) atcBtn?.classList.remove('hidden');
            }
          } else {
            const klaviyoContainer = this.querySelector('.klaviyo-product-container');
            if (isOOS) {
              klaviyoContainer?.classList.remove('hidden');
              atcBtn?.classList.add('hidden');
            } else {
              klaviyoContainer?.classList.add('hidden');
              if (variant?.available) atcBtn?.classList.remove('hidden');
            }
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.openCtlAtcAfterAdd = false;
        this.lastAddedCartItem = null;

        if (evt.submitter && evt.submitter.type === "submit") {
          this.submitButton = evt.submitter;
        } else if (!this.submitButton || !this.submitButton.isConnected) {
          this.submitButton = this.querySelector('[type="submit"]')
            || (this.form.id && document.querySelector('[type="submit"][form="' + CSS.escape(this.form.id) + '"]'));
        }
        if (!this.submitButton) return;

        // Footwear M&M card with no size chosen: never add a random size.
        if (this.dataset.mmSizeRequired === 'true') {
          const sizeSelect = this.querySelector('select.product-variant-id');
          if (sizeSelect && !sizeSelect.value) {
            this.classList.add('product-card--mm-size-error');
            sizeSelect.focus();
            try { sizeSelect.showPicker?.(); } catch (e) { /* needs user activation; focus is enough */ }
            return;
          }
        }

        if (this.submitButton.classList.contains("disabled")) {
          scrollToTargetAdjusted(
            document.querySelector(".ProductMn__GridItem")
          );
          return;
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Check if this is sticky ATC and no variant is selected
        const isStickyATC = this.closest('.stickyAddToCart') !== null;
        const variantSelectsElement = document.querySelector('variant-selects');
        const hasSelectedVariant = variantSelectsElement && variantSelectsElement.classList.contains('variant-selected');

        if (isStickyATC && !hasSelectedVariant) {
          // Scroll to variant selector
          const variantSelector = document.querySelector('.variant-picker__wrapper, .product-form__input');
          if (variantSelector) {
            const headerHeightStr = getComputedStyle(document.body).getPropertyValue('--header-height');
            const headerHeight = parseInt(headerHeightStr, 10) || 0;
            const elementTop = variantSelector.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementTop - headerHeight - 20; // 20px extra padding

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner")?.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        // M&M popup purchase attribution: tag adds made from inside the popup
        // with a hidden line item property (underscore = hidden in checkout and
        // on the order page). The Gadget app reads `_mm` on order line items to
        // report "Purchased from popup". Value = popup trigger, same as mmTrack.
        if (this.classList.contains('product-card--mm')) {
          formData.set('properties[_mm]', this.closest('.popup--atc-mode') ? 'atc' : 'default');
        }
        const sectionIdForRender = this.dataset.sectionId || document.querySelector('variant-selects')?.dataset.section;
        if (sectionIdForRender) {
          formData.set('sections', sectionIdForRender);
          formData.set('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            /* Process GWP before publishing events and updating UI.
               Optional + non-fatal: gwp-manager.js (which defines window.processGWP)
               is only loaded when settings.gwp_enable is on, and a throw here would
               skip the cart:refresh dispatch below, leaving a stale drawer. */
            if (typeof window.processGWP === 'function') {
              try {
                await window.processGWP(response, 'product-form-cart-add');
              } catch (gwpError) {
                console.error('GWP processing failed:', gwpError);
              }
            }
            const isCtlFormSubmission = this.classList.contains('product-card--mm');
            const isInsideAtcCtlPopup = isCtlFormSubmission && this.closest('.popup--atc-mode');

            if (!isCtlFormSubmission) {
              // Keep CTL content fresh for subsequent opens from the PDP add flow.
              this.rerenderCtlFromSections(response.sections);
            } else if (isInsideAtcCtlPopup) {
              this.rerenderCtlFreeShippingFromSections(response.sections);
              // Don't rerender while popup is open; just hide the added card and keep shopping flow uninterrupted.
              this.markCurrentCtlCardAsInCart();
              this.closeAtcCtlIfNoProductsLeft();
            }
            updateMmDebugPanels();

            if (isCtlFormSubmission) {
              window.mmTrack?.('item_added', {
                trigger: isInsideAtcCtlPopup ? 'atc' : 'default',
                productHandle: response.product_handle || response.handle || null,
                productTitle: response.product_title || response.title || null,
                variantId: response.variant_id ? String(response.variant_id) : (response.id ? String(response.id) : null),
                variantTitle: response.variant_title && response.variant_title !== 'Default Title' ? response.variant_title : null,
                price: typeof response.price === 'number' ? response.price : null,
              });
            }

            const ctlDlgForAtc = document.querySelector('.ctl-new__dialog');
            const mmAtcPopupEnabled = ctlDlgForAtc?.dataset.mmAtcPopupEnabled === 'true';
            // Only the PDP main product-form should trigger the M&M ATC popup
            // auto-open. Both flavors of card are also <product-form> elements:
            //   - horizontal (M&M, Look): <product-form class="product-card ...">
            //   - default: <product-card> wraps <product-form>
            // The PDP main form has neither shape: not classed product-card, and
            // not nested inside one.
            const shouldOpenCtlAtcModal =
              !this.classList.contains('product-card--mm') &&
              !this.classList.contains('product-card') &&
              !this.closest('product-card') &&
              ctlDlgForAtc && mmAtcPopupEnabled;
            if (shouldOpenCtlAtcModal) {
              this.openCtlAtcAfterAdd = true;
              this.lastAddedCartItem = response;
            }

            // Card-triggered M&M: a DEFAULT product-card add (home page, product
            // recommendations, etc.) on an enabled surface opens the M&M popup
            // instead of the cart drawer — same behaviour as the PDP add. Only
            // default cards have a <product-card> wrapper; the PDP main form,
            // M&M popup cards, and Look horizontal cards do not, so they're
            // excluded automatically.
            const isDefaultCardAdd = !shouldOpenCtlAtcModal && !!this.closest('product-card');
            if (isDefaultCardAdd && window.MixAndMatchCards && window.MixAndMatchCards.isSurfaceEnabled && window.MixAndMatchCards.isSurfaceEnabled()) {
              this.openCardMmAfterAdd = true;
              this.lastAddedCartItem = response;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            // New cart: re-render the drawer + bubble via the cart-drawer component.
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner")?.classList.add("hidden");

            // Adds made from INSIDE the M&M popup (either mode) must not pop the
            // cart drawer over it — the cart is a native <dialog> in the top
            // layer, so a fresh showModal() would cover the M&M drawer. The
            // popup's own sticky footer "View cart" button takes the user to the
            // cart when they're done; meanwhile cart:refresh keeps it in sync.
            // (In ATC mode, closeAtcCtlIfNoProductsLeft still opens the cart when
            // the last eligible item is added.)
            const isInsideMmPopup = this.classList.contains('product-card--mm') && this.closest('.ctl-new__dialog');
            const shouldOpenCartDrawer = !isInsideMmPopup && !this.openCtlAtcAfterAdd && !this.openCardMmAfterAdd;

            if (shouldOpenCartDrawer) {
              document.dispatchEvent(new CustomEvent('cart:open'));
            }

            if (this.openCtlAtcAfterAdd && this.lastAddedCartItem) {
              const didOpenAtcModal = this.openCtlAtcModal(this.lastAddedCartItem);
              if (!didOpenAtcModal) {
                document.dispatchEvent(new CustomEvent('cart:open'));
              }
            } else if (this.openCardMmAfterAdd && this.lastAddedCartItem && window.MixAndMatchCards) {
              // Card popup is fetched async; open the cart drawer only if it
              // doesn't show (no eligible M&M / fetch failed).
              const added = this.lastAddedCartItem;
              Promise.resolve(window.MixAndMatchCards.openForAdd(added)).then((opened) => {
                if (!opened) document.dispatchEvent(new CustomEvent('cart:open'));
              });
            }

            const addedToCartMessage = this.submitButton.querySelector(".added-to-cart-text");
            if(addedToCartMessage) {
              this.submitButton.classList.add("atc--added-to-cart");

              setTimeout(() => {
                this.submitButton.classList.remove("atc--added-to-cart");
              }, 3000)
            }
          });
      }

      openCtlAtcModal(addedItem) {
        const ctlDialog = document.querySelector('.ctl-new__dialog');
        if (!ctlDialog || ctlDialog.dataset.mmAtcPopupEnabled !== 'true') return false;

        const variantSelects = document.querySelector('variant-selects');
        let addedVariant = variantSelects?.currentVariant;
        if (!addedVariant) {
          try {
            const addedId = Number(addedItem?.variant_id || addedItem?.id);
            addedVariant = variantSelects?.getVariantData?.().find((v) => v.id === addedId);
          } catch (e) { /* no variant data — preselect falls back to the page selection */ }
        }
        if (variantSelects && addedVariant) variantSelects._mmAddedVariant = addedVariant;
        variantSelects?.preselectCtlVariants?.(addedVariant);

        const titleEl = ctlDialog.querySelector('.ctl-new__atc-product-title');
        const sizeEl = ctlDialog.querySelector('.ctl-new__atc-product-size');
        const sizeWrap = ctlDialog.querySelector('.ctl-new__atc-product-size-wrap');

        const addedTitle = addedItem?.product_title || addedItem?.title || '';
        const addedSize = addedItem?.variant_title && addedItem.variant_title !== 'Default Title' ? addedItem.variant_title : '';

        if (titleEl) titleEl.textContent = addedTitle;
        if (sizeEl) sizeEl.textContent = addedSize;
        sizeWrap?.classList.toggle('hidden', !addedSize);

        const hasAtcMatch = ctlDialog.querySelector('.product-card--mm:not(.product-card--mm-atc-hidden):not(.product-card--mm-atc-price-excluded)');
        if (!hasAtcMatch) {
          return false;
        }

        const productKey = String(
          addedItem?.product_handle ||
          addedItem?.handle ||
          addedItem?.product_id ||
          addedItem?.id ||
          addedTitle
        );
        if (!this.canShowMmAtcPopup(ctlDialog, productKey)) {
          return false;
        }

        document.querySelector('cart-drawer')?.close?.();

        ctlDialog.openModal({ mode: 'atc' });
        this.recordMmAtcPopupShow(ctlDialog, productKey);
        return true;
      }

      rerenderCtlFromSections(sections) {
        if (!sections) return;
        const sectionId = this.dataset.sectionId || document.querySelector('variant-selects')?.dataset.section;
        const html = sectionId ? sections[sectionId] : null;
        if (!html) return;

        const parsed = document.createElement('div');
        parsed.innerHTML = html;
        const newWrapper = parsed.querySelector('.complete-the-look__wrapper');
        const currentWrapper = document.querySelector('.complete-the-look__wrapper');
        if (newWrapper && currentWrapper) {
          currentWrapper.replaceWith(newWrapper);
        }
      }

      rerenderCtlFreeShippingFromSections(sections) {
        if (!sections) return;
        const sectionId = this.dataset.sectionId || document.querySelector('variant-selects')?.dataset.section;
        const html = sectionId ? sections[sectionId] : null;
        if (!html) return;

        const parsed = document.createElement('div');
        parsed.innerHTML = html;

        /* A/B TEST (snippets/ig-cart-test.liquid): the free-shipping module now
           renders once per arm inside .ctl-new__atc-shipping, so sync the arms as
           a set. Replacing the first [data-mm-free-shipping] would only ever
           refresh whichever arm comes first in the DOM and leave the other stale
           — and arm B additionally appears and disappears with cart.item_count,
           so a plain replaceWith cannot express it either.

           Post-test, once the losing arm is deleted and the winner unwrapped,
           this falls through to the single-node path below. */
        const currentHost = document.querySelector('.ctl-new__dialog .ctl-new__atc-shipping');
        const newHost = parsed.querySelector('.ctl-new__atc-shipping');
        const currentArms = currentHost ? [...currentHost.querySelectorAll('[data-ig-arm]')] : [];

        if (currentHost && newHost && currentArms.length) {
          /* Anchor on what follows the arms — the estimated-shipping tail, which
             this function has never refreshed and still must not. */
          const anchor = currentArms[currentArms.length - 1].nextSibling;
          currentArms.forEach((el) => el.remove());
          newHost.querySelectorAll('[data-ig-arm]').forEach((el) => {
            currentHost.insertBefore(el, anchor);
          });

          /* The Snow Shop promo goal box (snippets/cart-gwp-goal.liquid) sits in
             the shared tail after the arms and changes with the cart too, so swap
             it as well; it may appear or disappear. */
          const currentGoal = currentHost.querySelector('.gwp-goal');
          const newGoal = newHost.querySelector('.gwp-goal');
          if (currentGoal && newGoal) currentGoal.replaceWith(newGoal);
          else if (currentGoal) currentGoal.remove();
          else if (newGoal) currentHost.insertBefore(newGoal, anchor);
          return;
        }

        const newShipping = parsed.querySelector('[data-mm-free-shipping]');
        // Scope to the popup the add happened IN. On the product page there can
        // be TWO .ctl-new__dialog in the DOM — the product's own M&M popup and
        // the card-triggered popup — so a document-wide query would swap the
        // wrong (hidden) one's bar and leave the open popup stale.
        const currentShipping = (this.closest('.ctl-new__dialog') || document).querySelector('[data-mm-free-shipping]');
        if (newShipping && currentShipping) {
          currentShipping.replaceWith(newShipping);
        }
      }

      getMmAtcFrequencyConfig(ctlDialog) {
        const num = (value, fallback) => {
          const parsed = parseInt(value, 10);
          return Number.isFinite(parsed) ? parsed : fallback;
        };
        return {
          frequencyLimitsEnabled: ctlDialog?.dataset.mmAtcFrequencyLimits === 'true',
          maxPerProduct: num(ctlDialog?.dataset.mmAtcMaxShowsPerProduct, 2),
          maxGlobal: num(ctlDialog?.dataset.mmAtcMaxShowsGlobal, 3),
          cooldownMs: num(ctlDialog?.dataset.mmAtcCooldownMinutes, 10) * 60 * 1000,
          sessionWindowMs: num(ctlDialog?.dataset.mmAtcSessionWindowMinutes, 60) * 60 * 1000,
          storageKey: MM_ATC_FREQ_STORAGE_KEY,
        };
      }

      getMmAtcFrequencyState(config) {
        const now = Date.now();
        const freshState = () => ({
          firstShownAt: 0,
          expiresAt: now + config.sessionWindowMs,
          lastShownAt: 0,
          globalCount: 0,
          perProduct: {},
        });

        try {
          const raw = localStorage.getItem(config.storageKey);
          if (!raw) return freshState();
          const parsed = JSON.parse(raw);
          if (!parsed || typeof parsed !== 'object') return freshState();
          if (!parsed.expiresAt || now > parsed.expiresAt) return freshState();
          return {
            firstShownAt: parsed.firstShownAt || 0,
            expiresAt: parsed.expiresAt,
            lastShownAt: parsed.lastShownAt || 0,
            globalCount: parsed.globalCount || 0,
            perProduct: parsed.perProduct || {},
          };
        } catch {
          return freshState();
        }
      }

      saveMmAtcFrequencyState(config, state) {
        try {
          localStorage.setItem(config.storageKey, JSON.stringify(state));
        } catch {
          // Ignore storage failures; popup behavior gracefully degrades.
        }
        updateMmDebugPanels();
      }

      canShowMmAtcPopup(ctlDialog, productKey) {
        const config = this.getMmAtcFrequencyConfig(ctlDialog);
        if (!config.frequencyLimitsEnabled) return true;
        const state = this.getMmAtcFrequencyState(config);
        const now = Date.now();
        const productCount = state.perProduct[productKey] || 0;

        if (config.cooldownMs > 0 && now - state.lastShownAt < config.cooldownMs) return false;
        if (state.globalCount >= config.maxGlobal) return false;
        if (productCount >= config.maxPerProduct) return false;
        return true;
      }

      recordMmAtcPopupShow(ctlDialog, productKey) {
        const config = this.getMmAtcFrequencyConfig(ctlDialog);
        if (!config.frequencyLimitsEnabled) return;
        const state = this.getMmAtcFrequencyState(config);
        const now = Date.now();
        if (!state.firstShownAt) {
          state.firstShownAt = now;
          state.expiresAt = state.firstShownAt + config.sessionWindowMs;
        }
        state.lastShownAt = now;
        state.globalCount = (state.globalCount || 0) + 1;
        state.perProduct[productKey] = (state.perProduct[productKey] || 0) + 1;
        this.saveMmAtcFrequencyState(config, state);
      }

      markCurrentCtlCardAsInCart() {
        const ctlForm = this.closest('.product-card--mm');
        if (!ctlForm) return;
        ctlForm.classList.add('product-card--mm-atc-hidden');
        ctlForm.classList.add('product-card--mm-hidden');
      }

      closeAtcCtlIfNoProductsLeft() {
        const dialog = this.closest('.ctl-new__dialog');
        if (!dialog || !dialog.classList.contains('popup--atc-mode')) return;
        const hasVisibleCards = dialog.querySelector('.product-card--mm:not(.product-card--mm-atc-hidden):not(.product-card--mm-hidden):not(.product-card--mm-atc-price-excluded)');
        if (!hasVisibleCards) {
          dialog.closeModal?.();
          // No eligible upsells left to add — drop the user into the cart drawer
          // so the auto-close doesn't leave them on an empty page with no signal.
          // The normal cart-drawer open in `finally` is suppressed for ATC-mode
          // submissions, so we have to do it here.
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        // Default product cards put <product-form> INSIDE <product-card>, with
        // the error container (.product-card__atc-error) in the sibling <a>
        // subtree — outside <product-form>. Walk up to the enclosing card.
        const enclosingCard = this.closest('product-card');
        const cardErrorEl = enclosingCard?.querySelector('.product-card__atc-error');
        if (cardErrorEl) {
          cardErrorEl.textContent = errorMessage || "";
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
// predictive-search.js
// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.predictiveSearchResults = this.querySelector(
//       "[data-predictive-search]"
//     );
//     this.allPredictiveSearchInstances =
//       document.querySelectorAll("predictive-search");
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = "";

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

//     this.input.addEventListener("focus", this.onFocus.bind(this));
//     this.addEventListener("focusout", this.onFocusOut.bind(this));
//     this.addEventListener("keyup", this.onKeyup.bind(this));
//     this.addEventListener("keydown", this.onKeydown.bind(this));
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       // Remove the results when they are no longer relevant for the new search term
//       // so they don't show up when the dropdown opens again
//       this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
//     }

//     // Update the term asap, don't wait for the predictive search query to finish loading
//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);

//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       return;
//     }

//     this.getSearchResults(this.searchTerm);
//   }

//   onFormSubmit(event) {
//     if (
//       !this.getQuery().length ||
//       this.querySelector('[aria-selected="true"] a')
//     )
//       event.preventDefault();
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = "";
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (!currentSearchTerm.length) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       // Search term was changed from other search input, treat it as a user change
//       this.onChange();
//     } else if (this.getAttribute("results") === "true") {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();

//     switch (event.code) {
//       case "ArrowUp":
//         this.switchOption("up");
//         break;
//       case "ArrowDown":
//         this.switchOption("down");
//         break;
//       case "Enter":
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     // Prevent the cursor from moving in the input when using the up and down arrow keys
//     if (event.code === "ArrowUp" || event.code === "ArrowDown") {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector(
//       "[data-predictive-search-search-for-text]"
//     );
//     const currentButtonText = searchForTextElement?.innerText;
//     if (currentButtonText) {
//       if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
//         // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute("open")) return;

//     const moveUp = direction === "up";
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     // Filter out hidden elements (duplicated page and article resources) thanks
//     // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
//     const allVisibleElements = Array.from(
//       this.querySelectorAll("li, button.predictive-search__item")
//     ).filter((element) => element.offsetParent !== null);
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = "";

//     if (!moveUp && selectedElement) {
//       activeElementIndex =
//         selectedElementIndex === allVisibleElements.length - 1
//           ? 0
//           : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex =
//         selectedElementIndex === 0
//           ? allVisibleElements.length - 1
//           : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute("aria-selected", true);
//     if (selectedElement) selectedElement.setAttribute("aria-selected", false);

//     this.input.setAttribute("aria-activedescendant", activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector(
//       '[aria-selected="true"] a, button[aria-selected="true"]'
//     );

//     if (selectedOption) selectedOption.click();
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(" ", "-").toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       return;
//     }

//     fetch(
//       `${routes.predictive_search_url}?q=${encodeURIComponent(
//         searchTerm
//       )}&section_id=predictive-search`,
//       {
//         signal: this.abortController.signal,
//       }
//     )
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, "text/html")
//           .querySelector("#shopify-section-predictive-search").innerHTML;
//         // Save bandwidth keeping the cache in all instances synced
//         this.allPredictiveSearchInstances.forEach(
//           (predictiveSearchInstance) => {
//             predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
//           }
//         );
//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         if (error?.code === 20) {
//           // Code 20 means the call was aborted
//           return;
//         }
//         this.close();
//         throw error;
//       });
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement =
//       this.statusElement || this.querySelector(".predictive-search-status");
//     this.loadingText =
//       this.loadingText || this.getAttribute("data-loading-text");

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute("loading", true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute("aria-hidden", "false");
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute("aria-hidden", "true");
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute("results", true);

//     this.setLiveRegionResults();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute("loading");
//     this.setLiveRegionText(
//       this.querySelector("[data-predictive-search-live-region-count-value]")
//         .textContent
//     );
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight -
//       document.querySelector(".section-header").getBoundingClientRect().bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight =
//       this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute("open", true);
//     this.input.setAttribute("aria-expanded", true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = "";
//       this.removeAttribute("results");
//     }
//     const selected = this.querySelector('[aria-selected="true"]');

//     if (selected) selected.setAttribute("aria-selected", false);

//     this.input.setAttribute("aria-activedescendant", "");
//     this.removeAttribute("loading");
//     this.removeAttribute("open");
//     this.input.setAttribute("aria-expanded", false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute("style");
//   }
// }

// customElements.define("predictive-search", PredictiveSearch);
// facets.js
// class FacetFiltersForm extends HTMLElement {
//   constructor() {
//     super();
//     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
//     this.debouncedOnSubmit = debounce((event) => {
//       this.onSubmitHandler(event);
//     }, 500);

//     const facetForm = this.querySelector("form");
//     facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

//     const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
//     if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
//   }

//   static setListeners() {
//     const onHistoryChange = (event) => {
//       const searchParams = event.state
//         ? event.state.searchParams
//         : FacetFiltersForm.searchParamsInitial;
//       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
//       FacetFiltersForm.renderPage(searchParams, null, false);
//     };
//     window.addEventListener("popstate", onHistoryChange);
//   }

//   static toggleActiveFacets(disable = true) {
//     document.querySelectorAll(".js-facet-remove").forEach((element) => {
//       element.classList.toggle("disabled", disable);
//     });
//   }

//   static renderPage(searchParams, event, updateURLHash = true) {
//     FacetFiltersForm.searchParamsPrev = searchParams;
//     const sections = FacetFiltersForm.getSections();
//     // Not on a collection page — nothing to render
//     if (!sections.length) return;
//     const countContainer = document.getElementById("ProductCount");
//     const countContainerDesktop = document.getElementById(
//       "ProductCountDesktop"
//     );
//     const loadingSpinners = document.querySelectorAll(
//       ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
//     );
//     loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
//     document
//       .getElementById("ProductGridContainer")
//       .querySelector(".collection")
//       .classList.add("loading");
//     if (countContainer) {
//       countContainer.classList.add("loading");
//     }
//     if (countContainerDesktop) {
//       countContainerDesktop.classList.add("loading");
//     }

//     sections.forEach((section) => {
//       let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
//       if (
//         url.includes(`&filter.v.availability=1`) ||
//         url.includes(`&filter.v.availability=0`)
//       ) {
//         url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
//       } else {
//         url = `${window.location.pathname}?section_id=${section.section}&${searchParams}&filter.v.availability=1`;
//       }
//       const filterDataUrl = (element) => element.url === url;
//       FacetFiltersForm.filterData.some(filterDataUrl)
//         ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
//         : FacetFiltersForm.renderSectionFromFetch(url, event);
//     });

//     if (searchParams.includes("&filter.v.availability=1")) {
//       if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
//     } else {
//       if (updateURLHash)
//         FacetFiltersForm.updateURLHash(
//           `${searchParams}&filter.v.availability=1`
//         );
//     }
//   }

//   static renderSectionFromFetch(url, event) {
//     fetch(url)
//       .then((response) => response.text())
//       .then((responseText) => {
//         const html = responseText;
//         FacetFiltersForm.filterData = [
//           ...FacetFiltersForm.filterData,
//           { html, url },
//         ];
//         FacetFiltersForm.renderFilters(html, event);
//         FacetFiltersForm.renderProductGridContainer(html);
//         FacetFiltersForm.renderProductCount(html);
//         if (typeof initializeScrollAnimationTrigger === "function")
//           initializeScrollAnimationTrigger(html.innerHTML);
//       });
//   }

//   static renderSectionFromCache(filterDataUrl, event) {
//     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
//     FacetFiltersForm.renderFilters(html, event);
//     FacetFiltersForm.renderProductGridContainer(html);
//     FacetFiltersForm.renderProductCount(html);
//     if (typeof initializeScrollAnimationTrigger === "function")
//       initializeScrollAnimationTrigger(html.innerHTML);
//   }

//   static renderProductGridContainer(html) {
//     document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
//       .parseFromString(html, "text/html")
//       .getElementById("ProductGridContainer").innerHTML;

//     document
//       .getElementById("ProductGridContainer")
//       .querySelectorAll(".scroll-trigger")
//       .forEach((element) => {
//         element.classList.add("scroll-trigger--cancel");
//       });

//     setTimeout(function () {
//       if (window.screen.width > 749) {
//         let products$List = document.querySelector(
//           `[section="dx-new-product-grid"]`
//         );
//         let Outer$Height = document.querySelector(
//           ".shopify-section-group-header-group"
//         ).clientHeight;
//         window.scrollTo({
//           top: products$List.offsetTop - Outer$Height,
//           behavior: "smooth",
//         });
//       }
//     }, 100);
//   }

//   static renderProductCount(html) {
//     const count = new DOMParser()
//       .parseFromString(html, "text/html")
//       .getElementById("ProductCount").innerHTML;
//     const container = document.getElementById("ProductCount");
//     const containerDesktop = document.getElementById("ProductCountDesktop");
//     container.innerHTML = count;
//     container.classList.remove("loading");
//     if (containerDesktop) {
//       containerDesktop.innerHTML = count;
//       containerDesktop.classList.remove("loading");
//     }
//     const loadingSpinners = document.querySelectorAll(
//       ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
//     );
//     loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
//   }

//   static renderFilters(html, event) {
//     const parsedHTML = new DOMParser().parseFromString(html, "text/html");
//     const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
//       "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
//     );
//     const facetDetailsElementsFromDom = document.querySelectorAll(
//       "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
//     );

//     Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
//       if (
//         !Array.from(facetDetailsElementsFromFetch).some(
//           ({ id }) => currentElement.id === id
//         )
//       ) {
//         currentElement.remove();
//       }
//     });

//     const matchesId = (element) => {
//       const jsFilter = event ? event.target.closest(".js-filter") : undefined;
//       return jsFilter ? element.id === jsFilter.id : false;
//     };
//     const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
//       (element) => !matchesId(element)
//     );
//     const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
//       matchesId
//     );

//     facetsToRender.forEach((elementToRender, index) => {
//       const currentElement = document.getElementById(elementToRender.id);
//       if (currentElement) {
//         document.getElementById(elementToRender.id).innerHTML =
//           elementToRender.innerHTML;
//       } else {
//         if (index > 0) {
//           const { className: previousElementClassName, id: previousElementId } =
//             facetsToRender[index - 1];
//           if (elementToRender.className === previousElementClassName) {
//             document.getElementById(previousElementId).after(elementToRender);
//             return;
//           }
//         }

//         if (elementToRender.parentElement) {
//           document
//             .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
//             .before(elementToRender);
//         }
//       }
//     });

//     FacetFiltersForm.renderActiveFacets(parsedHTML);
//     FacetFiltersForm.renderAdditionalElements(parsedHTML);

//     if (countsToRender) {
//       const closestJSFilterID = event.target.closest(".js-filter").id;

//       if (closestJSFilterID) {
//         FacetFiltersForm.renderCounts(
//           countsToRender,
//           event.target.closest(".js-filter")
//         );
//         FacetFiltersForm.renderMobileCounts(
//           countsToRender,
//           document.getElementById(closestJSFilterID)
//         );

//         const newFacetDetailsElement =
//           document.getElementById(closestJSFilterID);
//         const newElementSelector = newFacetDetailsElement.classList.contains(
//           "mobile-facets__details"
//         )
//           ? `.mobile-facets__close-button`
//           : `.facets__summary`;
//         const newElementToActivate =
//           newFacetDetailsElement.querySelector(newElementSelector);
//         if (newElementToActivate) newElementToActivate.focus();
//       }
//     }
//   }

//   static renderActiveFacets(html) {
//     const activeFacetElementSelectors = [
//       ".active-facets-mobile",
//       ".active-facets-desktop",
//       ".WpTitleHdFacets",
//     ];

//     activeFacetElementSelectors.forEach((selector) => {
//       const activeFacetsElement = html.querySelector(selector);
//       if (!activeFacetsElement) return;
//       document.querySelector(selector).innerHTML =
//         activeFacetsElement.innerHTML;
//     });

//     FacetFiltersForm.toggleActiveFacets(false);

//     document.querySelectorAll(".FacetsFilterLytW").forEach((elm) => {
//       elm.children.length == 0
//         ? document.querySelectorAll(".WpContainerFAcetslyt ").forEach((elm) => {
//             elm.classList.add("NoActiveFilters");
//           })
//         : document.querySelectorAll(".WpContainerFAcetslyt ").forEach((elm) => {
//             elm.classList.remove("NoActiveFilters");
//           });
//     });
//   }

//   static renderAdditionalElements(html) {
//     const mobileElementSelectors = [
//       ".mobile-facets__open",
//       ".mobile-facets__count",
//       ".sorting",
//       ".ItemWpCounderApplied",
//     ];

//     mobileElementSelectors.forEach((selector) => {
//       if (!html.querySelector(selector)) return;
//       document.querySelector(selector).innerHTML =
//         html.querySelector(selector).innerHTML;
//     });

//     document
//       .getElementById("FacetFiltersFormMobile")
//       .closest("menu-drawer")
//       .bindEvents();
//   }

//   static renderCounts(source, target) {
//     const targetSummary = target.querySelector(".facets__summary");
//     const sourceSummary = source.querySelector(".facets__summary");

//     if (sourceSummary && targetSummary) {
//       targetSummary.outerHTML = sourceSummary.outerHTML;
//     }

//     const targetHeaderElement = target.querySelector(".facets__header");
//     const sourceHeaderElement = source.querySelector(".facets__header");

//     if (sourceHeaderElement && targetHeaderElement) {
//       targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
//     }

//     const targetWrapElement = target.querySelector(".facets-wrap");
//     const sourceWrapElement = source.querySelector(".facets-wrap");

//     if (sourceWrapElement && targetWrapElement) {
//       const isShowingMore = Boolean(
//         target.querySelector("show-more-button .label-show-more.hidden")
//       );
//       if (isShowingMore) {
//         sourceWrapElement
//           .querySelectorAll(".facets__item.hidden")
//           .forEach((hiddenItem) =>
//             hiddenItem.classList.replace("hidden", "show-more-item")
//           );
//       }

//       targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
//     }
//   }

//   static renderMobileCounts(source, target) {
//     const targetFacetsList = target.querySelector(".mobile-facets__list");
//     const sourceFacetsList = source.querySelector(".mobile-facets__list");

//     if (sourceFacetsList && targetFacetsList) {
//       targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
//     }
//   }

//   static updateURLHash(searchParams) {
//     history.pushState(
//       { searchParams },
//       "",
//       `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
//     );
//   }

//   static getSections() {
//     const productGrid = document.getElementById("product-grid");
//     if (!productGrid) return [];
//     return [{ section: productGrid.dataset.id }];
//   }

//   createSearchParams(form) {
//     const formData = new FormData(form);
//     return new URLSearchParams(formData).toString();
//   }

//   onSubmitForm(searchParams, event) {
//     FacetFiltersForm.renderPage(searchParams, event);
//   }

//   onSubmitHandler(event) {
//     event.preventDefault();
//     const sortFilterForms = document.querySelectorAll(
//       "facet-filters-form form"
//     );
//     if (event.srcElement.className == "mobile-facets__checkbox") {
//       const searchParams = this.createSearchParams(
//         event.target.closest("form")
//       );
//       this.onSubmitForm(searchParams, event);
//     } else {
//       const forms = [];
//       const isMobile =
//         event.target.closest("form").id === "FacetFiltersFormMobile" ||
//         event.target.closest("form").id === "FacetFiltersFormMobileNW";

//       sortFilterForms.forEach((form) => {
//         if (!isMobile) {
//           if (
//             form.id === "FacetSortForm" ||
//             form.id === "FacetFiltersForm" ||
//             form.id === "FacetSortDrawerForm"
//           ) {
//             const noJsElements = document.querySelectorAll(".no-js-list");
//             noJsElements.forEach((el) => el.remove());
//             forms.push(this.createSearchParams(form));
//           }
//         } else if (
//           form.id === "FacetFiltersFormMobile" ||
//           form.id === "FacetFiltersFormMobileNW"
//         ) {
//           forms.push(this.createSearchParams(form));
//         }
//       });
//       this.onSubmitForm(forms.join("&"), event);
//     }
//   }

//   onActiveFilterClick(event) {
//     event.preventDefault();
//     FacetFiltersForm.toggleActiveFacets();
//     const url =
//       event.currentTarget.href.indexOf("?") == -1
//         ? ""
//         : event.currentTarget.href.slice(
//             event.currentTarget.href.indexOf("?") + 1
//           );
//     FacetFiltersForm.renderPage(url);
//   }
// }

// FacetFiltersForm.filterData = [];
// FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// customElements.define("facet-filters-form", FacetFiltersForm);
// FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll(".InputFeedPriceWp").forEach((element) =>
//       element.addEventListener("change", this.onRangeChange.bind(this))
//     );
//     this.setMinAndMaxValues();
//     const fromSlider = this.querySelector(".FromSliderRangeBarInput");
//     const toSlider = this.querySelector(".ToSliderRangeBarInput");
//     const fromInput = this.querySelector(".FromInputBoxappraed");
//     const toInput = this.querySelector(".ToInputBoxappraed");
//     this.fillSlider(fromSlider, toSlider, "#C6C6C6", "#733D80", toSlider);
//     fromSlider.oninput = () =>
//       this.controlFromSlider(fromSlider, toSlider, fromInput);
//     toSlider.oninput = () =>
//       this.controlToSlider(fromSlider, toSlider, toInput);
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll("input");
//     const RangeBar = this.querySelectorAll("[js-rangebar]");
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     const minRange = RangeBar[0];
//     const maxRange = RangeBar[1];
//     if (maxInput.value)
//       minInput.setAttribute("max", maxInput.value),
//         (minRange.value = minInput.value),
//         (this.querySelector(".ToSliderRangeBarInput").value = maxInput.value);
//     if (minInput.value)
//       maxInput.setAttribute("min", minInput.value),
//         (maxRange.value = maxInput.value);
//     if (minInput.value === "")
//       maxInput.setAttribute("min", 0), (minRange.value = 0);
//     if (maxInput.value === "")
//       minInput.setAttribute("max", maxInput.getAttribute("max")),
//         (maxRange.value = maxInput.getAttribute("max"));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute("min"));
//     const max = Number(input.getAttribute("max"));
//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }

//   controlFromSlider(fromSlider, toSlider, fromInput) {
//     const [from, to] = this.getParsed(fromSlider, toSlider);
//     this.fillSlider(fromSlider, toSlider, "#000", "#000", toSlider);
//     fromInput.value = from;
//     if (from > to) {
//       return false;
//     }
//   }

//   controlToSlider(fromSlider, toSlider, toInput) {
//     const [from, to] = this.getParsed(fromSlider, toSlider);
//     this.fillSlider(fromSlider, toSlider, "#000", "#000", toSlider);
//     toSlider.value = to;
//     toInput.value = to;
//     if (from > to) {
//       return false;
//     }
//   }

//   getParsed(currentFrom, currentTo) {
//     const from = parseInt(currentFrom.value, 10);
//     const to = parseInt(currentTo.value, 10);
//     return [from, to];
//   }

//   fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
//     let rangeDistance = to.max - to.min;
//     let fromPosition = from.value - to.min;
//     let toPosition = to.value - to.min;
//     if (fromPosition > toPosition) {
//       let spare = fromPosition;
//       fromPosition = toPosition;
//       toPosition = spare;
//     }
//   }
// }

// customElements.define("price-range", PriceRange);

// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector("a");
//     facetLink.setAttribute("role", "button");
//     facetLink.addEventListener("click", this.closeFilter.bind(this));
//     facetLink.addEventListener("keyup", (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
//     });
//   }

//   closeFilter(event) {
//     event.preventDefault();
//     const form =
//       this.closest("facet-filters-form") ||
//       document.querySelector("facet-filters-form");
//     form.onActiveFilterClick(event);
//   }
// }

// customElements.define("facet-remove", FacetRemove);
// // show-more.js
// if (!customElements.get("show-more-button")) {
//   customElements.define(
//     "show-more-button",
//     class ShowMoreButton extends HTMLElement {
//       constructor() {
//         super();
//         const button = this.querySelector("button");
//         button.addEventListener("click", (event) => {
//           this.expandShowMore(event);
//           const nextElementToFocus = event.target
//             .closest(".parent-display")
//             .querySelector(".show-more-item");
//           if (
//             nextElementToFocus &&
//             !nextElementToFocus.classList.contains("hidden") &&
//             nextElementToFocus.querySelector("input")
//           ) {
//             nextElementToFocus.querySelector("input").focus();
//           }
//         });
//       }
//       expandShowMore(event) {
//         const parentDisplay = event.target
//           .closest('[id^="Show-More-"]')
//           .closest(".parent-display");
//         const parentWrap = parentDisplay.querySelector(".parent-wrap");
//         this.querySelectorAll(".label-text").forEach((element) =>
//           element.classList.toggle("hidden")
//         );
//         parentDisplay
//           .querySelectorAll(".show-more-item")
//           .forEach((item) => item.classList.toggle("hidden"));
//         if (!this.querySelector(".label-show-less")) {
//           this.classList.add("hidden");
//         }
//       }
//     }
//   );
// }
// // main-search.js

// class MainSearch extends SearchForm {
//   constructor() {
//     super();
//     this.allSearchInputs = document.querySelectorAll('input[type="search"]');
//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     let allSearchForms = [];
//     this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
//     this.input.addEventListener("focus", this.onInputFocus.bind(this));
//     if (allSearchForms.length < 2) return;
//     allSearchForms.forEach((form) =>
//       form.addEventListener("reset", this.onFormReset.bind(this))
//     );
//     this.allSearchInputs.forEach((input) =>
//       input.addEventListener("input", this.onInput.bind(this))
//     );
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.keepInSync("", this.input);
//     }
//   }

//   onInput(event) {
//     const target = event.target;
//     this.keepInSync(target.value, target);
//   }

//   onInputFocus() {
//     const isSmallScreen = window.innerWidth < 750;
//     if (isSmallScreen) {
//       this.scrollIntoView({ behavior: "smooth" });
//     }
//   }

//   keepInSync(value, target) {
//     this.allSearchInputs.forEach((input) => {
//       if (input !== target) {
//         input.value = value;
//       }
//     });
//   }
// }

// customElements.define("main-search", MainSearch);

// product-info.js

if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {

        // On a color-swap reinit the app doesn't auto-run, so we kick it manually
        // before setting up our observer so its buttons are already in the DOM
        if (window.__colorSwapReinit && this.querySelector('[data-sizebay]')) {
          if (typeof SizebayInit === 'function') {
            console.log("🚀 ~ connectedCallback ~ SizebayInit:")
            SizebayInit();
          } else if (!window.__sizebayLazyLoaded) {
            // Swapped from a custom-guide colour, where SizeBay was never loaded: load it now
            // (scripts inside swapped-in markup don't execute). The prescript runs SizebayInit itself.
            window.__sizebayLazyLoaded = true;
            const szb = document.createElement('script');
            szb.async = true;
            szb.src = 'https://static.sizebay.technology/2392/prescript.js';
            document.head.appendChild(szb);
          }
        }

        // setTimeout(() => {
          this.setupSizeAssistantObserver();
        // }, 100);

        // Setup sticky add to cart visibility
        this.setupStickyAddToCart();

        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        if (this.stickyAddToCartCleanup) {
          this.stickyAddToCartCleanup();
        }
      }

      setupSizeAssistantObserver() {
        const variantPicker = this.querySelector('.variant-picker__wrapper .product-form__input');
        console.log("🚀 ~ setupSizeAssistantObserver ~ variantPicker:", variantPicker)
        if (!variantPicker) return;

        // debugger;
    
        const sizeAssistantWrapper = this.querySelector('.size-assistant__wrapper');
        console.log("🚀 ~ setupSizeAssistantObserver ~ sizeAssistantWrapper:", sizeAssistantWrapper)
        if (!sizeAssistantWrapper) return;
        if (!sizeAssistantWrapper.hasAttribute('data-sizebay')) return; // our guide owns the block, or SizeBay is off
    
        let sizeGuideFound = false;
        let observer = null;
        let timeout = null;
    
        const checkForSizeGuide = () => {
          // Look for size guide app elements
          const vfrContainer = variantPicker.querySelector('.vfr__container') ||
                              document.querySelector('.vfr__container');
          const szbContainer = variantPicker.querySelector('#szb-container') ||
                              document.querySelector('#szb-container');
    
          const sizeGuideApp = vfrContainer || szbContainer;
    
          if (sizeGuideApp && !sizeGuideFound) {
            
            console.log("🚀 ~ checkForSizeGuide ~ sizeGuideFound:", sizeGuideFound)
    
            // Show the size assistant wrapper
            
    
            // Check which buttons exist in the app
            const vfrButton = sizeGuideApp.querySelector('#szb-vfr-button');
            const measurementsButton = sizeGuideApp.querySelector('#szb-measurements-button');
    
            // Show corresponding custom buttons and set up click handlers
            if (vfrButton) {
              const customAssistantButton = sizeAssistantWrapper.querySelector('.size-assistant__button--assistant');
              if (customAssistantButton) {
                sizeAssistantWrapper.classList.remove('hidden');
                sizeGuideFound = true;
                customAssistantButton.classList.remove('hidden');
                customAssistantButton.addEventListener('click', () => {
                  vfrButton.click();
                });
              }
            }
    
            if (measurementsButton) {
              const customChartButton = sizeAssistantWrapper.querySelector('.size-assistant__button--chart');
              if (customChartButton) {
                sizeAssistantWrapper.classList.remove('hidden');
                sizeGuideFound = true;
                customChartButton.classList.remove('hidden');
                customChartButton.addEventListener('click', () => {
                  measurementsButton.click();
                });
              }
            }
            
    
            // Clean up
            // if (observer) observer.disconnect();
            if (timeout) clearTimeout(timeout);
          }
        };
    
        // Set up MutationObserver
        observer = new MutationObserver(checkForSizeGuide);
        observer.observe(variantPicker, {
          childList: true,
          subtree: true
        });
    
        // Initial check in case the element is already there
        checkForSizeGuide();
    
        // Timeout after 10 seconds if no size guide is found
        timeout = setTimeout(() => {
          if (observer) observer.disconnect();
          // Size assistant remains hidden if no size guide is found
        }, 10000);
      }

      setupStickyAddToCart() {
        const staticAddToCart = this.querySelector('.staticAddToCart');
        const stickyAddToCart = this.querySelector('.stickyAddToCart');

        if (!staticAddToCart || !stickyAddToCart) return;

        let ticking = false;

        const checkVisibility = () => {
          // Only run on mobile (< 950px)
          if (window.innerWidth >= 950) {
            stickyAddToCart.classList.remove('sticky-visible');
            return;
          }

          // Get header height from CSS variable
          const headerHeightStr = getComputedStyle(document.body).getPropertyValue('--header-height');
          const headerHeight = parseInt(headerHeightStr, 10) || 0;

          // Check if we've scrolled past the static ATC (it's above the viewport)
          const rect = staticAddToCart.getBoundingClientRect();
          const scrolledPastStatic = rect.bottom < headerHeight;

          // Only show sticky when scrolled PAST the static ATC (not above it)
          if (scrolledPastStatic) {
            stickyAddToCart.classList.add('sticky-visible');
          } else {
            stickyAddToCart.classList.remove('sticky-visible');
          }

          ticking = false;
        };

        // Scroll listener with RAF throttling
        const onScroll = () => {
          if (!ticking) {
            requestAnimationFrame(checkVisibility);
            ticking = true;
          }
        };

        // Resize listener with debounce
        let resizeTimeout;
        const onResize = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            checkVisibility();
          }, 150);
        };

        // Add event listeners
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize);

        // Initial check
        checkVisibility();

        // Store cleanup function for disconnectedCallback
        this.stickyAddToCartCleanup = () => {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) clearTimeout(resizeTimeout);
        };
      }
    

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
// pickup-availability.js
if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList
        );
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview"
        ).outerHTML;
        this.setAttribute("available", "");

        document.body.appendChild(
          sectionInnerHTML.querySelector("pickup-availability-drawer")
        );
        const colorClassesToApply =
          this.dataset.productPageColorScheme.split(" ");
        colorClassesToApply.forEach((colorClass) => {
          document
            .querySelector("pickup-availability-drawer")
            .classList.add(colorClass);
        });

        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            document
              .querySelector("pickup-availability-drawer")
              .show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest("pickup-availability-drawer") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
        trapFocus(this);
      }
    }
  );
}
(function() {
  var updateCart = function() {
   fetch(`${routes.cart_url}?section_id=main-cart-items`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'); 
      const sourceQty = html.querySelector('.ContainerWPElementMain'); 
      const targetElement = document.querySelector('.ContainerWPElementMain');
      if (targetElement && sourceQty) {
        targetElement.innerHTML = sourceQty.innerHTML;
      }
      dcartAPI.discount.setTotals();
    });
  };
  window.addEventListener("sc:discount.calculated", updateCart);
  window.addEventListener("sc:discount.remove", updateCart);
})();
